import RichTextInput from "ra-input-rich-text";
import { Datagrid, DateField, DateInput, Edit, EditProps, List, ListProps, required, SimpleForm, Tab, TabbedShowLayout, TextField, TextInput, TopToolbar, ListButton, Show, ShowProps, EmailField, RichTextField, BooleanField, BooleanInput, ReferenceField } from "react-admin";
import CastingGallery from "./Utils/Casting/CastingGallery";
import { Box } from '@material-ui/core';

const CastingApplicationShowActions = ({ basePath }: any) => (
  <TopToolbar>
  <ListButton basePath={basePath} />
  </TopToolbar>
);

export const CastingApplicationShow = (props: ShowProps) => {
  return (
    <Show  actions={<CastingApplicationShowActions />} {...props}>
      <TabbedShowLayout>
        <Tab label="summary">
          <ReferenceField label="Utilisateur" source="user.id" reference="User" link="edit" emptyText="Aucun">
            <TextField source="id" />
          </ReferenceField>
          <EmailField label="Email" source="email" />
          <TextField label="Tél." source="phone" />
          <TextField label="Prénom" source="firstName" />
          <TextField label="Nom" source="lastName" />
          <TextField label="Date de naissance" source="birthdate" />
          <TextField label="Ville de résidence" source="city" />
          <DateField label="Date de vérification de l'âge" source="ageVerifiedAt" />
          <RichTextField label="Motivation pour participer au casting" source="participationMotivation" />
          <BooleanField label="Comprend la différence entre tournage et rencontres" source="understandsDifference" />
          <RichTextField label="Explication de la différence" source="differenceExplanation" />
          <TextField label="Familiarité avec les émissions LittleAngel" source="familiarity" />
          <BooleanField label="Ebook acheté" source="orderedPreparationDocument" />
          <BooleanField label="Complet" source="applicationSent" />
        </Tab>
        <Tab label="Gallery">
            <CastingGallery {...props} />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
const castingFilters = [
  <TextInput label="Search" source="q" alwaysOn />,
  <BooleanInput label="Complet" source="applicationSent"  />,
  <BooleanInput label="Ebook acheté" source="orderedPreparationDocument"  />,
  <DateInput label="Date min" source="date_min" alwaysOn />,
  <DateInput label="Date max" source="date_max" alwaysOn />,
];
export const CastingApplicationList = (props: ListProps) => {
  return (
    <List
      {...props}
      bulkActionButtons={false}
      sort={{ field: "createdAt", order: "DESC" }}
      filters={castingFilters}
    >
      <Datagrid rowClick="show">
        <EmailField source="email" />
        <ReferenceField label="Utilisateur" source="user.id" reference="User" link="edit" emptyText="Aucun">
            <TextField source="id" />
        </ReferenceField>
        <BooleanField label="Ebook acheté" source="orderedPreparationDocument" />
        <TextField label="Prénom" source="firstName" />
        <TextField label="Nom" source="lastName" />
        <TextField label="Ville de résidence" source="city" />
        {/* <ColoredBooleanField className="true" label="Ebook acheté" source="orderedPreparationDocument" /> */}
        <BooleanField label="Complet" source="applicationSent" />
        <DateField label="Date de vérification de l'âge" source="ageVerifiedAt" />
        <DateField label="Date de soumission" source="createdAt" />
        <DateField label="Date de mise à jour" source="updatedAt" />

        {/* <BulkDeleteButton /> */}
      </Datagrid>
    </List>
  );
};

export const CastingApplicationEdit = (props: EditProps) => {
  const validateRequired = [required()];
  return (
    <Edit mutationMode="pessimistic" {...props}>
      <TabbedShowLayout>
        <Tab label="summary">
      <SimpleForm >
        <TextInput label="Email" source="email" validate={validateRequired}  />
        <TextInput label="Prénom" source="firstName" validate={validateRequired}  />
        <TextInput label="Nom" source="lastName" validate={validateRequired}  />
        <TextInput label="Tél." source="phone"  />
        <TextInput label="Date de naissance" source="birthdate"  />
        <TextInput label="Ville de résidence" source="city"  />
        <DateInput label="Date de vérification de l'âge" source="ageVerifiedAt" validate={validateRequired}  />
        <RichTextInput
          label="Motivation pour participer au casting"
          source="participationMotivation"
          toolbar={[
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "link"],

            // [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ]}
          validate={validateRequired}
           
        />
        <RichTextInput label="Motivation pour participer au casting" source="participationMotivation"  />
        <BooleanInput label="Comprend la différence entre tournage et rencontres" source="understandsDifference"  />
        <RichTextField label="Explication de la différence" source="differenceExplanation" />
        <TextField label="Familiarité avec les émissions LittleAngel" source="familiarity" />
        <BooleanInput label="Ebook acheté" source="orderedPreparationDocument"  />
        <BooleanInput label="Complet" source="applicationSent"  />

      </SimpleForm>
      </Tab>
      </TabbedShowLayout>
      
    </Edit>
  );
};